import { pgTable, uuid, text, foreignKey } from 'drizzle-orm/pg-core';
import { relations } from 'drizzle-orm';
import { TaskStatus } from '../../enums';
import { orgTableBase, orgPrimaryKey } from '../org-id';
import { Team } from '../roster/team';
import { Profile } from '../profile';
import { configColumn, calendarPrintOptionDefaults, } from '../../json';
export const CalendarPrintTask = pgTable('calendar_print_task', {
    ...orgTableBase,
    teamId: uuid('team_id').notNull(),
    profileId: uuid('profile_id').notNull(),
    status: TaskStatus('status').notNull(),
    pdfUrl: text('pdf_url'),
    printOptions: configColumn('print_options', calendarPrintOptionDefaults).notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    profileFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
export const CalendarPrintTask_Relations = relations(CalendarPrintTask, ({ one }) => ({
    team: one(Team, {
        fields: [CalendarPrintTask.orgId, CalendarPrintTask.teamId],
        references: [Team.orgId, Team.id],
    }),
    profile: one(Profile, {
        fields: [CalendarPrintTask.orgId, CalendarPrintTask.profileId],
        references: [Profile.orgId, Profile.id],
    }),
}));
//# sourceMappingURL=index.js.map